import * as React from "react"
import errorImg from "../../assets/images/error.svg"
import "./ErrorBoundary.styles.scss"
import _ from "../../utils/lodashUtils"

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      hasError: false,
    }
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error, hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // error reporting, logging calls go here.
  }

  render() {
    const { hasError, error } = this.state
    return hasError ? <Error errorDetails={error} /> : this.props.children
  }
}

export const Error = props => {
  const { errorText, errorDetails, errorSubtext } = props
  return (
    <section className="global-error">
      <img
        className="error-graphic"
        src={errorImg}
        alt="error. something went wrong"
      />
      <h1 className="error-text">{errorText || "Something went wrong."}</h1>
      <h2 className="error-subtext">
        {errorSubtext || "We are looking into it."}
      </h2>
      <p className="error-details">{_.get(errorDetails, "message", "")}</p>
    </section>
  )
}
